<template>
    <LayoutSub className="overseas">
        <SubpageTitleContainer :title="`해외 간편결제`"
            :subText="`2015년 국내 최초 알리페이 독점 서비스 오픈을 시작으로 위챗페이, 라인페이(대만) 서비스를 추가 오픈하며 업계 최대의 해외 간편결제 서비스를 제공하고 있습니다.`">
        </SubpageTitleContainer>
        <SubSection class="pt-0">
            <RedTitleRow title="알리페이 플러스">
                <li>
                    <div class="img_area">
                        <img src="@/assets/sub4_logo_1.png" alt="" />
                    </div>
                    <div class="text_area">
                        <p>
                            알리페이 플러스는 한국 카카오페이를 비롯해 홍콩 알리페이HK(AlipayHK), 필리핀 지캐시(Gcash), 태국 트루머니(TrueMoney),
                            말레이시아 터치앤고(Touch'n'Go) 등 각국의 간편결제 서비스를 전 세계 13억명의 사용자들에게 제공하고 있습니다.
                        </p>
                    </div>
                </li>
            </RedTitleRow>
            <RedTitleRow title="위챗페이">
                <li>
                    <div class="img_area">
                        <img src="@/assets/sub4_logo_2.png" alt="" />
                    </div>
                    <div class="text_area">
                        <p>
                            위챗페이는 중국 최대 소셜 네트워크 어플인 WeChat에 내장된 디지털 지갑 서비스로 매달 수십억 건의 거래가 처리되는 중국의
                            대량 모바일 결제 시스템입니다. 뛰어난 속도와 저렴한 수수료로 중국의 많은 사용자들이 일상적인 거래에 위챗페이를 사용하고
                            있습니다.
                        </p>
                    </div>
                </li>
            </RedTitleRow>
            <RedTitleRow title="라인페이">
                <li>
                    <div class="img_area">
                        <img src="@/assets/sub4_logo_3.png" alt="" />
                    </div>
                    <div class="text_area">
                        <p>
                            라인페이는 라인 메신저와 연동하여 사용할 수 있는 간편결제 서비스로 대만 인구의 80%가 사용하는 모바일 결제 선호도 1위
                            브랜드입니다. 라인페이를 통해 라인 제휴사와 연계된 관광 콘텐츠를 제공함으로써 대만 관광객 유치 및 매출 상승의 효과를
                            기대할 수 있습니다.
                        </p>
                    </div>
                </li>
            </RedTitleRow>
        </SubSection>

        <SubSection type="wide">
            <SubTitle3 listStyle="dot">특징</SubTitle3>
            <div class="table-2grid">
                <TableRow_2grid src="sub4_ic_1.png" title="전용회선 운용"
                    content="업계 유일의 해외 간편결제 전용회선 운용으로 보안 리스크 없이 안정적인 승인 서비스를 제공합니다." />
                <TableRow_2grid src="sub4_ic_2.png" title="최단기간 대응 및 복구 보장"
                    content="실시간 장애감시 체계, IDC 센터 이중 운용 및 다국어 고객센터 등을 통한 고객 응대로 장애 발생 시 빠른 대처가 가능합니다." />
                <TableRow_2grid src="sub4_ic_3.png" title="편리한 결제"
                    content="카드나 현금을 통한 결제보다 간편하며 서명이 불필요하기 때문에 빠르게 결제를 진행할 수 있습니다." />
                <TableRow_2grid src="sub4_ic_4.png" title="뛰어난 프로모션 효과"
                    content="중국 홈페이지, APP 등 플랫폼을 통한 가맹점 홍보가 가능하며 페이백 이벤트 등 수시 프로모션으로 고객의 구매를 촉진할 수 있습니다." />
            </div>
        </SubSection>

        <SubSection>
            <SubTitle3 listStyle="dot">대금 정산 프로세스</SubTitle3>
            <div class="image_box">
                <img src="@/assets/sub4_image_1.png" alt="" />
            </div>
            <p>
                *알리,위챗페이: 한국, 중국, 홍콩, 싱가폴, 미국 공휴일 적용/라인페이 : 한국 공휴일 적용<br />
                *일반 카드사와 동일하게 가맹점 이용 은행과 관계없이 승인 – 취소 대금 상계 지원
            </p>
        </SubSection>

        <SubSection type="wide">
            <SubTitle3 listStyle="dot">결제 방법</SubTitle3>
            <div class="grid-2">
                <div class="line_box">
                    <div class="line_box_header">
                        <div class="header-title-area">오프라인 결제</div>
                    </div>
                    <div class="line-box-body">
                        <div class="content">
                            <ul class="line_box_list">
                                <li>
                                    <span class="num">01
                                        <div class="line">
                                            <img src="@/assets/sub4_dot_line.png" alt="" />
                                        </div>
                                    </span>
                                    <div class="text">단말기에서 금액 입력 후 <br />승인 요청</div>
                                </li>
                                <li>
                                    <span class="num">02
                                        <div class="line">
                                            <img src="@/assets/sub4_dot_line.png" alt="" />
                                        </div>
                                    </span>
                                    <div class="text">고객 APP에서 <br />결제코드가 활성화된 <br />바코드 리딩</div>
                                </li>
                                <li>
                                    <span class="num">03</span>
                                    <div class="text">결제 완료</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="line_box">
                    <div class="line_box_header">
                        <div class="header-title-area">온라인 결제</div>
                    </div>
                    <div class="line-box-body">
                        <div class="content">
                            <ul class="line_box_list">
                                <li>
                                    <span class="num">01
                                        <div class="line">
                                            <img src="@/assets/sub4_dot_line.png" alt="" />
                                        </div>
                                    </span>
                                    <div class="text">QR 리딩</div>
                                </li>
                                <li>
                                    <span class="num">
                                        02
                                        <div class="line">
                                            <img src="@/assets/sub4_dot_line.png" alt="" />
                                        </div>
                                    </span>
                                    <div class="text">금액 확인 후 <br />비밀번호 입력</div>
                                </li>
                                <li>
                                    <span class="num">03</span>
                                    <div class="text">결제 완료</div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </SubSection>

        <SubSection class="pb-0">
            <SubTitle3 listStyle="dot">서비스 신청 안내</SubTitle3>
            <div class="grid-3">
                <CardBox3 :idx="1" :title="`서비스 신청 및 상담`" content="온라인 고객 문의 또는 고객센터(<a href='tel:1600-1234'>1600-1234</a>)를 통해 <br />상담을 접수합니다.">
                    <OrangeLineButton :text="`서비스 신청`" to="/cs/voc" />
                </CardBox3>
                <CardBox3 :idx="2" :title="`담당자 배정`"
                    content="지정된 담당자가 가맹점에 방문하여 해외 간편결제와 <br />관련된 사항을 성실하게 답변해 드립니다." />
                <CardBox3 :idx="3" :title="`서비스 오픈`"
                    content="가맹점 계약이 완료되면 해외 간편결제 서비스를 <br />이용하실 수 있습니다.<br />단말기/프로그램 설치 등 서비스 운영에 필요한 사항에 <br />대한 지원이 가능합니다." />
            </div>
        </SubSection>
    </LayoutSub>
</template>
<script>
import CardBox3 from '@/components/CardBox3.vue';
import OrangeLineButton from '@/components/OrangeLineButton.vue';
import RedTitleRow from '@/components/RedTitleRow.vue';
import SubpageTitleContainer from '@/components/SubpageTitleContainer.vue';
import SubSection from '@/components/SubSection.vue';
import SubTitle3 from '@/components/SubTitle3.vue';
import TableRow_2grid from '@/components/TableRow_2grid.vue';
import LayoutSub from '@/layouts/LayoutSub.vue';

export default {
    components: {
        LayoutSub,
        SubpageTitleContainer,
        SubSection,
        SubTitle3,
        CardBox3,
        OrangeLineButton,
        TableRow_2grid,
        RedTitleRow,
    },
};
</script>
